import { App, Table } from 'antd';
import React, {
  useCallback, useContext, useMemo, useState,
} from 'react';
import { captureException } from 'utils/errors';
import http, { getHttpErrorMessage } from 'utils/http';
import { generateColumns } from 'utils/table';
import { EventEmitter } from 'utils/event';
import { MenuContext } from '../constants';
import columns from './columns';
import { getFilteredModifiers } from './utils';

function List({ searchTerm, setCurrentModifier }) {
  const { isGlobal, modifiers } = useContext(MenuContext);
  const { message, modal } = App.useApp();
  const [loadingModifiers, setLoadingModifiers] = useState({});

  const onEdit = useCallback((modifier) => {
    setCurrentModifier(modifier);
  }, [setCurrentModifier]);

  const onChangeAvailability = (modifier) => {
    if (modifier.is_active) {
      modal.confirm({
        title: `Disabling ${modifier?.name || modifier?.title}`,
        content: `By confirming this modal the selected modifier (${modifier?.name || modifier?.title}) will be disabled and won't show on the customer's menu.`,
        okButtonProps: { danger: false },
        okText: 'Confirm',
        width: 572,
        onOk: () => handleToggle(modifier),
      });
    } else {
      handleToggle(modifier);
    }
    function handleToggle(modifier) {
      setLoadingModifiers((prev) => ({ ...prev, [modifier.id]: true }));
      return http.put(`v1/modifiers/${modifier?.id}/`, { is_active: !modifier.is_active })
        .then(() => {
          EventEmitter.emit('refresh_modifiers');
        })
        .catch((e) => {
          captureException(e);
          message.error(getHttpErrorMessage(e));
        })
        .finally(() => {
          setLoadingModifiers((prev) => ({ ...prev, [modifier.id]: false }));
        });
    }
  };

  const normalizedColumns = useMemo(() => generateColumns(columns({
    isGlobal,
    onEdit,
    onChangeAvailability,
    loadingModifiers,
  })), [isGlobal, loadingModifiers]);

  return (
    <Table
      columns={normalizedColumns}
      dataSource={getFilteredModifiers({ searchTerm, modifiers })}
      scroll={{ x: 780 }}
      pagination={{
        showTotal: (total) => `Total ${total} results`,
      }}
      rowClassName="cursor-pointer"
    />
  );
}

export default List;
